import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
//import { getFamilias } from '../actions'

import ProductoHeader from '../components/productoheader'

class Home extends Component{

	constructor(props) {
	    super(props);
	    this.state = {
	      flias:[]
	    }
	}

  	componentWillMount() {
    	//this.props.getFamilias()
  	}

  	render() {
		return (
			<section>
          	{ this.props.flias.length > 0   &&
          	<ProductoHeader productos={this.props.flias} ubicacion="home" />
          	}
			<section className="container p-5">
				<h4>Pulseras, Entradas  en stock o hechas a medida exactamente según sus especificaciones.</h4>
				<p><br/>Si  estas buscando estos tipos productos  en una amplia variedad de materiales y colores, en Velton Accesos los tenes. <br/><br/>
				Estamos orgullosos de ofrecer los mejores tiempos de respuesta  en el sector.<br/><br/>
				No importa cuáles sean sus necesidades, tenemos nuestros productos  en stock que pueden enviarse el mismo día,  o al dia siguiente.<br/><br/>
				Cuando pida productos de Ingreso Facil, le garantizamos que llegarán rápidamente. Sabemos que contamos con los mejores tiempos de entrega, calidad y precio.</p>

				{/*
				<p>Si busca pulseras en una variedad de materiales y colores, ¡Wristband Resources lo tiene cubierto! Estamos orgullosos de ofrecer los mejores tiempos de respuesta de pulseras en la industria. No importa cuáles sean sus necesidades, tenemos pulseras en existencia que pueden enviarse el mismo día, o pulseras personalizadas que pueden enviarse tan pronto como el siguiente día hábil. Cuando nos pide pulseras, le garantizamos que llegarán rápidamente. Lideramos la industria con nuestra velocidad, calidad y precio.</p>
				<p>También ofrecemos la más amplia selección de productos de pulseras en cualquier lugar, incluidas pulseras de colores y una variedad de otros patrones y opciones. Llevamos Tyvek (papel), plástico, tela y vinilo para la seguridad de la multitud y con fines de identificación. Si está planeando un evento, puede que le interesen nuestras pulseras de silicona. Estos son los más comúnmente utilizados para promociones o eventos relacionados con causas y eventos para recaudar fondos. A diferencia de las pulseras de otros proveedores, nuestras pulseras de silicona de calidad tienen la garantía de ser duraderas y de larga duración. Todas nuestras pulseras para la venta ofrecen opciones en stock y personalizadas, que le brindan la flexibilidad necesaria para su próximo evento.</p>
				<p>También ofrecemos cordones e insignias de cordón. Las eslingas se pueden usar con fines de seguridad o identificación, o como cordones de llavero. Refuerce su marca personalizando sus cuerdas de seguridad, incluida la sumblimación (a todo color) o tejida.</p>
				<h4>¿Por qué pedir pulseras de recursos de pulsera?</h4>
				<p>Cuando nos compra pulseras, puede relajarse sabiendo que el servicio al cliente es nuestra principal prioridad. Con más de 20 años de experiencia en la industria, nos destacamos por brindarles a nuestros clientes el mejor servicio junto con precios bajos, plazos de entrega rápidos, envío rápido y descuentos en pulseras a granel disponibles por producto. Ya sea que esté buscando comprar pulseras para un evento determinado o muñequeras de colores de diseño personalizado para una recaudación de fondos, ¡estamos seguros de que tendremos lo que necesita! Mejoramos constantemente nuestros productos y métodos de impresión para estar a la vanguardia del juego. Nuestro personal de soporte de calidad conoce la industria de las pulseras y está encantado de atender cualquier inquietud que tenga sobre nuestros productos. Si no puede encontrar lo que está buscando o si tiene preguntas, comuníquese con nosotros para obtener una respuesta rápida.</p>
				*/}
			</section>
		</section>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
  return {
      flias: state.menu.flias
    }
}

const mapDispatchToProps = dispatch => {
  return {
   /* getFamilias: () => {
      dispatch(getFamilias())
    }*/
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)




// WEBPACK FOOTER //
// ./src/containers/home.js